import { CButton, CCol, CContainer, CRow } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import {CustomBreadcrumbs} from '../../components';
import { AppContext } from '../../context/AppContext';
import styles from './CompanyCategories.module.css';
import ProductsTable from '../../components/Table/ProductsTable';
import { useNavigate } from 'react-router-dom';
import CompanyCategoriesTable from '../../components/Table/CompanyCategoriesTable';



const CompanyCategories = () => {

    //Context
    const { state, getCompanyCategories } = React.useContext(AppContext);

    //States
    const columns = [
        {
          key: '',
          label: 'ID',
          _props: { scope: 'col' }
        },
        {
          key: 'title',
          label: 'Título',
          _props: { scope: 'col' }
        },
        {
          key: 'description',
          label: 'Descripción',
          _props: { scope: 'col' }
        },
        {
          key: 'actions',
          label: 'Acciones',
          _props: { scope: 'col' }
        }
    ];

    const navigate = useNavigate();

    //Effect
    useEffect(() => {
        getCompanyCategories();
    },[])


    return (
        <>
            <CustomBreadcrumbs parentTitle={'Veterinarias & lugares Pet Friendly'} activeTitle={"Categorías"} />
            <CContainer>
                <CRow className="justify-content-center">
                    <CCol lg={12}>
                        <div className={styles.orderContainer}>
                            {/* Order header */}
                            <div className={styles.orderHeader}>
                                <h2 className='title'>Categorías</h2>
                                <CButton 
                                    size="lg" 
                                    color="primary" 
                                    onClick={() => navigate("/dashboard/company-categories/add")} 
                                    className={styles.button}
                                >
                                    Agregar categoría
                                </CButton>
                            </div>
                        </div>
                        <div className={styles.productsContainer}>
                            <CompanyCategoriesTable
                                columns={columns} 
                                data={state?.companyCategories}
                                pagination={state?.productsPagination} 
                            />
                        </div>
                    </CCol>
                </CRow>
            </CContainer>
        </>
    );
};

export default CompanyCategories;
